import { createPopper }  from '@popperjs/core'
import getUniqueId from '../UniqueId'
let Tooltip = {
  init: init,
  destroy: destoryAll,
  reload: reload,
  uidList: []
}
let placementsStyleTagId = undefined

function init (options = undefined) {
  let refElements = document.querySelectorAll('[tooltip-label]')
  let refTooltipList = []
  let tooltipElList = []
  // eslint-disable-next-line new-cap
  let id = new getUniqueId()
  let offset = 4

  
  options ? options.transitionDuration ? setStylesToHead(options.transitionDuration) : setStylesToHead('0.3s') : setStylesToHead('0.3s')
  options ?  options.offset ? offset = options.offset : offset = 4 : offset = 4

  refElements.forEach(el => {
    const uid = id.generate()
    Tooltip.uidList.push('tooltip-id-' + uid)
    createToolTip(el.getAttribute('tooltip-label'), 'tooltip-id-' + uid, el.getAttribute('tooltip-overflow'))
    el.setAttribute('data-tooltip-id', 'tooltip-id-' + uid)
    refTooltipList.push(el)
  })

  let index = 0
  refTooltipList.forEach(el => {
    // eslint-disable-next-line no-new
    
    new createPopper(el, tooltipElList[index], {
      placement: el.getAttribute('tooltip-direction') ? el.getAttribute('tooltip-direction') : 'auto',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, offset],
          },
        },
      ],
    })
    setMouseHoverEvent(el, tooltipElList[index])
    index++
  })

  function createToolTip (label, id, overflow) {
    let div = document.createElement('div')
    div.classList.add('tooltip')
    if (overflow !== null){
      div.classList.add('overflow')
    }
    div.setAttribute('role', 'tooltip')
    div.style = 'z-index: -9999'
    div.setAttribute('data-tooltip-id', id)
	div.setAttribute('id', id)
    div.innerHTML = `${label}`
    tooltipElList.push(div)
    document.body.appendChild(div)
  }

  function setStylesToHead (transitionDuration) {
    let style = document.createElement('style')
    placementsStyleTagId = 'tooltip_placements' + new getUniqueId().generate()
    style.setAttribute('id', placementsStyleTagId)
    style.innerHTML = `
            [role="tooltip"] { opacity: 0; transition: opacity ${transitionDuration}}`
    document.head.appendChild(style)
  }

  function setMouseHoverEvent (refEl, tooltipRef) {
    refEl.addEventListener('mouseover', () => {
      tooltipRef.style.display = 'initial'
      tooltipRef.style.opacity = 1
      tooltipRef.style.removeProperty('z-index')
    })
    refEl.addEventListener('mouseleave', () => {
      tooltipRef.style.opacity = 0
      setTimeout(() => {
        tooltipRef.style.display = 'none'
      }, getTransitionDuration(options))
    })
  }
}
function destoryAll () {
  document.querySelectorAll('[role=tooltip]').forEach(el => {
    // el.parentNode.removeChild(el)
    if (Tooltip.uidList.includes(el.getAttribute('data-tooltip-id'))) { el.parentNode.removeChild(el) }
  })
  if(document.querySelector('#' + placementsStyleTagId)) document.querySelector('#' + placementsStyleTagId).remove()
  removeAllGeneratedIds()
}
// function getUniqueId () {
//   this.length = 8
//   this.timestamp = +new Date()

//   var _getRandomInt = function (min, max) {
//     return Math.floor(Math.random() * (max - min + 1)) + min
//   }

//   this.generate = function () {
//     var ts = this.timestamp.toString()
//     var parts = ts.split('').reverse()
//     var id = ''

//     for (var i = 0; i < this.length; ++i) {
//       var index = _getRandomInt(0, parts.length - 1)
//       id += parts[index]
//     }

//     return id
//   }
// }
function removeAllGeneratedIds () {
  document.querySelectorAll('[data-tooltip-id]').forEach(el => {
    if (Tooltip.uidList.includes(el.getAttribute('data-tooltip-id'))) { el.removeAttribute('data-tooltip-id') }
  })
}
function getTransitionDuration (options) {
  return options ? options.transitionDuration ? parseFloat(options.transitionDuration.replace('s', '')) * 1000 : 300 : 300
}
function reload () {
  destoryAll()
  init()
}
export default Tooltip
